'use client';

import type { ChangeEvent } from 'react';
import { useSearchParams } from 'next/navigation';
import { useCacheKey } from '@libs/common-next';
import css from './devtools.module.scss';

export function Experience() {
    const ck = useCacheKey();
    const sp = useSearchParams();

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        const params = new URLSearchParams(sp?.toString());
        params.set('experimentGroup', e.target.value);
        window.location.search = params.toString();
    };

    return (
        <>
            <p className={css.title}>Experience</p>

            <div className={css.experience}>
                {['fullsolution', 'searchbrowse', 'sfcc'].map(exp => (
                    <label key={exp} htmlFor={exp}>
                        {exp}
                        <input
                            id={exp}
                            type="radio"
                            name="experience"
                            value={exp}
                            onChange={onChange}
                            checked={
                                ck.cookies.get('x-petm-experiment-version') ===
                                exp
                            }
                        />
                    </label>
                ))}
            </div>
        </>
    );
}
